import { useState, useEffect, useRef } from 'react';

const projects = [
  { id: 1, name: 'Residencial Pinheiro', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/2cd48ee2-9a16-446b-8753-475f299f228f_RESIDENCIAL-PINHEIRO-1.png?v=a7693d8e556936250c04a1e837fbc49a' },
  { id: 2, name: 'Cozinha Natural', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/0e16f46a-4098-4f50-8dbe-a023ef15bbc2_COZINHA-NATURAL-1---Copia.png?v=957746df8cc8c2d6421cfef4b7947881' },
  { id: 3, name: 'Casa Leal', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/a722eb4c-6883-4607-b43c-1c093bc80825_CASA-LEAL-FACHADA---Copia.png?v=6f9b460fb0f6e6c8c1db7e5fab31a879' },
  { id: 4, name: 'Casa Família Pereira', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/53648f9a-5b87-4473-812d-95a9a3b3b329_CASA-FAMILIA-PEREIRA-2---Copia.png?v=2c50edc4c616bea9956f7a33439d357f' },
  { id: 5, name: 'Casa Cruz', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/2c6c6c6c-079c-4e64-9bb9-b902f7d73a91_CASA-CRUZ-2---Copia.png?v=26caaf54515c62e9658fafb54e001713' },
  { id: 6, name: 'Apê Santo', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/5c0aee4a-1e4f-4fe9-9c24-f769ee24bd4d_APE-SANTOS---Copia.png?v=2e4d07d87c05f9de2af51df9ebbc0d2f' },
  { id: 7, name: 'Apê Nordeste', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/da011a25-07d8-4d7a-a8ca-6c8ce29161e9_APE-NORDESTE---Copia.png?v=9cfd91ecd842a3e4dccf920c98d32933' },
  { id: 8, name: 'Apê Ivanete', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/5bd17282-797c-4f95-a333-df3092e78d89_APE-IVANETE.png?v=03af6e9084112aa19b5f9afee5c61c27' },
  { id: 9, name: 'Apê Campo Belo', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/35422236-2b38-45de-8edb-cddbf4458851_APE-CAMPO-BELO.png?v=4fe7cf062624ddfe2ab183d552c179ae' },
  { id: 10, name: 'Apê 6C', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/4eb332a2-4b4c-4f9d-bc38-f137cb8de1c9_APE-6C.png?v=c12d7ce9b8bb7701856dff45aac70229' },
  { id: 11, name: 'Apartamento Verde', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/3c0bbf51-0e92-46c1-bc97-20fe52890752_APARTAMENTO-VERDE.png?v=42d16a55610bd22bf75de3b96f418571' },
  { id: 12, name: 'Apartamento 121', image: 'https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/95740256-45f8-47a0-8236-d530d61cd1e6_APARTAMENTO-121.png?v=b8dd5ed432cb68c778b91617ba0fc41e' },
];

export default function Portfolio() {
  const [hoveredId, setHoveredId] = useState<number | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-p').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0) scale(1)';
              }, i * 60);
            });
          }
        });
      },
      { threshold: 0.05 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const prev = () => setActiveIndex((i) => Math.max(0, i - 1));
  const next = () => setActiveIndex((i) => Math.min(projects.length - 1, i + 1));

  return (
    <section id="portfolio" className="py-24 md:py-32 bg-white">
      <div ref={sectionRef} className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span
            className="reveal-p opacity-0 translate-y-6 transition-all duration-700 inline-flex items-center gap-2 px-4 py-1.5 border border-[#D6C4D6] text-[#301531] font-montserrat text-xs font-semibold tracking-[0.2em] uppercase rounded-full mb-5"
            style={{ transitionProperty: 'opacity, transform' }}
          >
            Projetos
          </span>
          <h2
            className="reveal-p opacity-0 translate-y-6 transition-all duration-700 font-gothic text-[#301531] block"
            style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)', transitionProperty: 'opacity, transform' }}
          >
            Nosso Portfólio
          </h2>
          <p
            className="reveal-p opacity-0 translate-y-6 transition-all duration-700 font-montserrat text-[#BCBDBF] text-base mt-4 max-w-xl mx-auto leading-relaxed"
            style={{ transitionProperty: 'opacity, transform' }}
          >
            Cada projeto é uma história única de transformação, planejamento e sofisticação
          </p>
        </div>

        {/* Desktop: 4-col grid */}
        {!isMobile ? (
          <div className="grid grid-cols-4 gap-5">
            {projects.map((project) => (
              <div
                key={project.id}
                className="reveal-p opacity-0 scale-95 transition-all duration-700 relative overflow-hidden rounded-2xl cursor-pointer group col-span-1"
                style={{ height: '260px', transitionProperty: 'opacity, transform' }}
                onMouseEnter={() => setHoveredId(project.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <img
                  src={project.image}
                  alt={`${project.name} - Projeto de interiores INTRÊ Arquitetura`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                <div
                  className={`absolute inset-0 flex items-end p-5 transition-all duration-300 ${
                    hoveredId === project.id ? 'opacity-100' : 'opacity-0'
                  }`}
                  style={{ background: 'linear-gradient(180deg, transparent 0%, rgba(48,21,49,0.85) 100%)' }}
                >
                  <span className="font-montserrat font-bold text-white text-sm">{project.name}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          /* Mobile: Finite carousel */
          <div className="relative">
            <div className="overflow-hidden rounded-2xl">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${activeIndex * 100}%)` }}
              >
                {projects.map((project) => (
                  <div key={project.id} className="w-full flex-shrink-0">
                    <div className="relative overflow-hidden rounded-2xl" style={{ height: '280px' }}>
                      <img
                        src={project.image}
                        alt={`${project.name} - Projeto de interiores INTRÊ Arquitetura`}
                        className="w-full h-full object-cover object-top"
                      />
                      <div
                        className="absolute inset-0 flex items-end p-5"
                        style={{ background: 'linear-gradient(180deg, transparent 40%, rgba(48,21,49,0.85) 100%)' }}
                      >
                        <span className="font-montserrat font-bold text-white text-base">{project.name}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Arrows */}
            <button
              onClick={prev}
              disabled={activeIndex === 0}
              className={`absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer transition-opacity duration-300 ${activeIndex === 0 ? 'opacity-30' : 'opacity-100'}`}
              style={{ boxShadow: '0 4px 16px rgba(48,21,49,0.18)' }}
              aria-label="Anterior"
            >
              <i className="ri-arrow-left-s-line text-[#301531] text-xl" />
            </button>
            <button
              onClick={next}
              disabled={activeIndex === projects.length - 1}
              className={`absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer transition-opacity duration-300 ${activeIndex === projects.length - 1 ? 'opacity-30' : 'opacity-100'}`}
              style={{ boxShadow: '0 4px 16px rgba(48,21,49,0.18)' }}
              aria-label="Próximo"
            >
              <i className="ri-arrow-right-s-line text-[#301531] text-xl" />
            </button>

            {/* Counter */}
            <div className="flex justify-center items-center gap-3 mt-5">
              <span className="font-montserrat text-[#301531] text-sm font-semibold">
                {activeIndex + 1}
              </span>
              <div className="flex gap-1.5">
                {projects.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveIndex(i)}
                    className={`rounded-full transition-all duration-300 cursor-pointer ${
                      i === activeIndex ? 'w-5 h-2 bg-[#301531]' : 'w-2 h-2 bg-[#D6C4D6]'
                    }`}
                    aria-label={`Ir para projeto ${i + 1}`}
                  />
                ))}
              </div>
              <span className="font-montserrat text-[#BCBDBF] text-sm">
                {projects.length}
              </span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
